import styled from 'styled-components';
import { styledDescriptions } from '../styled/mixin';
import { TaxInvoice } from '../../modules/invoices';
import { Button, Col, Descriptions, Row, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import { priceToString } from '../../util/utils';
import { useEffect, useState } from 'react';
import Link from 'antd/lib/typography/Link';

const StyledDiv = styled.div`
  ${styledDescriptions}
`;

interface TaxInvoiceDetailComponentProps {
  taxInvoice: TaxInvoice;
  moveToEditPage?: () => void;
  openPdfFile: (file: any) => void;
  deleteTaxInvoice: (taxInvoiceId: number) => void;
}

function TaxInvoiceDetailComponent({
  taxInvoice,
  moveToEditPage,
  openPdfFile,
  deleteTaxInvoice,
}: TaxInvoiceDetailComponentProps) {
  useEffect(() => {
    const fileList = taxInvoice.file.map((file: any) => (
      <li key={file.id}>
        <Link
          onClick={(e) => {
            e.stopPropagation();
            openPdfFile(file);
          }}
        >
          {file.name}
        </Link>
      </li>
    ));
    setPdfFileList(fileList);
  }, [taxInvoice.file, openPdfFile]);

  const [pdfFileList, setPdfFileList] = useState<any[]>([]);

  return (
    <StyledDiv>
      <Row justify="space-between" align="bottom">
        <Col>
          <Title level={3}>매입증빙 상세 (직접입력)</Title>
        </Col>
      </Row>

      <Row justify={'space-between'}>
        <Col>
          <Title level={5}>매입증빙 상세</Title>
        </Col>
        <Col>
          <Space>
            <Button size="small" onClick={moveToEditPage}>
              수정하기
            </Button>
            <Button
              size="small"
              onClick={() => deleteTaxInvoice(taxInvoice.id)}
            >
              삭제하기
            </Button>
          </Space>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Descriptions bordered column={2} size="small">
            <Descriptions.Item label="공급가액(원)">
              {priceToString(taxInvoice.supplyValue)}
            </Descriptions.Item>
            <Descriptions.Item label="부가세(원)">
              {priceToString(taxInvoice.taxAmt)}
            </Descriptions.Item>
            <Descriptions.Item label="합계금액(원)">
              {priceToString(taxInvoice.supplyValue + taxInvoice.taxAmt)}
            </Descriptions.Item>
            <Descriptions.Item label="작성일">
              {taxInvoice.reportingDate}
            </Descriptions.Item>
            <Descriptions.Item label="사업자 등록번호">
              {taxInvoice.supplierRegNumber ? taxInvoice.supplierRegNumber : ''}
            </Descriptions.Item>
            <Descriptions.Item label="공급자 상호">
              {taxInvoice.supplierCompanyName}
            </Descriptions.Item>
            <Descriptions.Item label="공급자 대표명">
              {taxInvoice.supplierName}
            </Descriptions.Item>
            <Descriptions.Item label="종류">
              {taxInvoice.type === '0' ? '세금계산서' : '현금영수증'}
            </Descriptions.Item>
            <Descriptions.Item label="대표품목" span={2}>
              {taxInvoice.repItems ?? ''}
            </Descriptions.Item>
            <Descriptions.Item
              label="설명"
              span={2}
              style={{ whiteSpace: 'pre-wrap' }}
            >
              {taxInvoice.description}
            </Descriptions.Item>

            <Descriptions.Item label="첨부파일" span={2}>
              {pdfFileList}
            </Descriptions.Item>
          </Descriptions>
        </Col>
      </Row>
    </StyledDiv>
  );
}
export default TaxInvoiceDetailComponent;
